export const environment = {
  name: 'Dev',
  development: true,
};
